import httpClient from "Api/httpClient";

const END_POINT = "/manufacturers";

const getManufacturers = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getManufacturer = (company_id) => {
    if (!company_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + company_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printManufacturer = (company_id) => {
    if (!company_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?company_id=" + company_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createManufacturers = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateManufacturers = (payload, company_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + company_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteManufacturers = (company_id) => {
    const DELETE_END_POINT = END_POINT + "/" + company_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getManufacturers, getManufacturer, printManufacturer, createManufacturers, updateManufacturers, deleteManufacturers };
